import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import dayjs from 'dayjs'
import axios from 'axios'
// Import System Lang Files
import el from './locale/el/index'
import en from './locale/en/index'
// Import dayjs Lang Files
import 'dayjs/locale/el'
import 'dayjs/locale/en'
// Import Moment Lang Files
import 'moment/dist/locale/el.js'

Vue.use(VueI18n)

const messages = {
  el: el,
  en: en
}

const numberFormats = {
  USD: {
    currency: {
      style          : 'currency',
      currency       : 'USD',
      currencyDisplay: 'symbol'
    }
  },
  GBP: {
    currency: {
      style          : 'currency',
      currency       : 'GBP',
      currencyDisplay: 'symbol'
    }
  },
  EUR: {
    currency: {
      style          : 'currency',
      currency       : 'EUR',
      currencyDisplay: 'symbol'
    }
  }
}

export const i18n = new VueI18n({
  locale               : import.meta.env.VITE_I18N_LOCALE || 'el',
  fallbackLocale       : import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  silentTranslationWarn: import.meta.env.MODE === 'production',
  numberFormats,
  messages
})

i18n.languages = Object.values(i18n.t('Common.Language')).filter(lang => lang.active && lang.pos)

export const setI18nLanguage = (lang) => {
  const lng = i18n.languages.find(l => l.locale === lang)
  lang = lng ? lng.locale : import.meta.env.VITE_I18N_LOCALE || import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'el'
  i18n.locale = lang

  moment.locale(lang)
  moment.relativeTimeThreshold('ss', 60)
  moment.updateLocale('el', {
    relativeTime: {
      future: 'in %s',
      past  : '%s ago',
      s     : '%d sec.',
      ss    : '%d seconds',
      m     : 'a minute',
      mm    : '%d minutes',
      h     : 'an hour',
      hh    : '%d hours',
      d     : 'a day',
      dd    : '%d days',
      M     : 'a month',
      MM    : '%d months',
      y     : 'a year',
      yy    : '%d years'
    }
  })
  moment.updateLocale('el', {
    relativeTime: {
      future: 'σε %s',
      past  : '%s πριν',
      s     : '%d δευτ.',
      ss    : '%d δευτ.',
      m     : '%d λεπτό',
      mm    : '%d λεπτά',
      h     : '%d ώρα',
      hh    : '%d ώρες',
      d     : '%d μέρα',
      dd    : '%d μέρες',
      M     : '%d μήνα',
      MM    : '%d μήνες',
      y     : '%d έτος',
      yy    : '%d έτη'
    }
  })

  if (dayjs) dayjs.locale(lang)

  axios.defaults.headers.common['Accept-Language'] = lang
  if (window.Vue) window.Vue.$vuetify.lang.current = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export const setI18nLanguageFromBrowser = () => {
  setI18nLanguage(getBrowserLocale())
}

export const getBrowserLocale = (countryCodeOnly = true) => {
  const navigatorLocale = navigator && navigator.languages && Array.isArray(navigator.languages) && navigator.languages.length ? navigator.languages[0] : navigator.language
  if (!navigatorLocale) return import.meta.env.VITE_I18N_LOCALE || import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'el'
  return countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim()
}

export default i18n
